// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + ({"140":"1e78b08f","239":"86bc6427","863":"reg-login"}[chunkId] || chunkId) + "." + {"72":"f67c2120a4613b6d","140":"3bbb0ef20887de38","239":"c4210096b6f55bde","863":"07cd73b3e53bd2f8","905":"f1a6ae5604f2e4b5"}[chunkId] + ".js";
};